import React, { useState } from 'react';
import './HeroSection.css';
import BookingModal from './BookingModal'; // import the modal component

function HeroSection() {
    const [isModalOpen, setIsModalOpen] = useState(false);

    return (
        <>
            <section id="hero" className="hero-section">
                <div className="hero-overlay"></div>
                <img
                    src="https://physiotherapistahmedabad.com/wp-content/uploads/2021/08/Slider_02.jpg"
                    alt="Hero"
                    className="hero-img"
                />
                <div className="hero-text">
                    <h2>Your Movement is Our Priority</h2>
                    <p>Professional physiotherapy and rehabilitation</p>
                    <a href="#services" className="btn desktop-only">View Services</a>

                    {/* Show "Online Book" on mobile only */}
                    <button
                        className="btn mobile-only"
                        onClick={() => setIsModalOpen(true)}
                    >
                        Online Book
                    </button>
                </div>
            </section>

            <BookingModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} />
            <button className="online-book-btn" onClick={() => setIsModalOpen(true)}>
                Online Book
            </button>

        </>
    );
}

export default HeroSection;
